import { createZodDto } from 'nestjs-zod/dto';
import { UserLoginServerFinalSchema } from './user-login-response.dto';
export const SsoAccountMergeFinalSchema = UserLoginServerFinalSchema.pick({
    userId: true,
    userEncryptedKey: true,
    userEncryptedKeySalt: true,
    userEncryptedKeyIterations: true,
    accessToken: true,
});
export class SsoAccountMergeFinalDto extends createZodDto(SsoAccountMergeFinalSchema) {
}
